<template>
  <v-app theme="light" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;">
    <!-- Navigation Sidebar - DESHABILITADO: Cada dashboard tiene su propia navegación -->
    <!-- 
    <SidebarNavigation 
      v-model:collapsed="sidebarCollapsed"
      @toggle="toggleSidebar"
    />
    -->
    
    <!-- Main Content -->
    <v-main>
      <v-container fluid class="pa-0">
        <router-view />
      </v-container>
      <!-- Botón flotante de notificaciones -->
      <div v-if="showBell" class="floating-bell">
        <NotificationBell />
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import NotificationBell from '@/components/notifications/NotificationBell.vue'
// import SidebarNavigation from '@/components/navigation/SidebarNavigation.vue' // Deshabilitado: cada dashboard tiene su navegación

// App principal de MGI Frontend Vue.js
const sidebarCollapsed = ref(false)

const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
}

// Mostrar campana sólo donde corresponda (autenticado y no layout minimal)
const route = useRoute()
const auth = useAuthStore()
const showBell = computed(() => {
  const isMinimal = route.meta?.layout === 'minimal'
  const isExcludedByName = route.name === 'Home' || route.name === 'RoleSelector'
  // Evitar campana flotante en SuperAdminDashboard: la campana vive en su propio header
  const isSuperAdminDashboard = route.name === 'SuperAdminDashboard'
  return !!auth.isAuthenticated && !isMinimal && !isExcludedByName && !isSuperAdminDashboard
})
</script>

<style scoped>
.v-main {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  min-height: 100vh !important;
}

/* Forzar tema claro globalmente */
:deep(.v-application) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
}

:deep(.v-main) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
}

:deep(.v-container) {
  background: transparent !important;
}

/* P13-V7B · the bell floats at the BOTTOM right. At the top right it sat over the app bar of every
   page that has one, covering the controls placed there — the shared shell's user menu (and with it
   the sign-out) could not be clicked. */
.floating-bell {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
}
</style>
